// extracted by mini-css-extract-plugin
export default {"container":"SaveButton_container__c+nBW","spinner":"SaveButton_spinner__dhxpO"};